import { FC } from "react";
import CustomTableForOrgDetails from "../../components/TableOrgDetails/CustomTableOrgDetails";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import { useStyles } from "./OrgDetails.styles";
import {
  Box,
  Divider,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
  Title,
  Text,
} from "@mantine/core";
import { useOrgIndividualsFilteredList } from "../../hooks/useOrgIndividualsFilteredList";

const OrgDetailsPage: FC = () => {
  const { classes } = useStyles();
  const token = useSelector((state: RootState) => state.auth.token);

  const {
    page,
    limit,
    kycStatus,
    regtankReattemptApproval,
    organizations,
    limits,
    kycStatusFilter,
    regtankReattemptApprovalFilter,
    paginatedOrgs,
    isLoading,
    error,
    refetch,
    handleSearchChange,
    handlePageChange,
    handleLimitChange,
    handleKycStatusChange,
    handleRegtankApprovalChange,
    totalCount,
  } = useOrgIndividualsFilteredList({
    token,
    isIndividual: false,
    includeResubmission: true,
  });

  if (error) {
    toast.error((error as Error).message);
  }

  return (
    <div>
      <Title order={1}>Organisations</Title>
      <Divider my="md" />
      <Box pos="relative">
        <LoadingOverlay visible={isLoading} />
        <Group align="end">
          <Select
            style={{ width: "130px", marginTop: "20px" }}
            label="KYC Status"
            value={kycStatus}
            onChange={handleKycStatusChange}
            data={kycStatusFilter}
          />
          <Select
            style={{ width: "200px", marginTop: "20px" }}
            label="Regtank Reattempt Approval"
            value={regtankReattemptApproval}
            onChange={handleRegtankApprovalChange}
            data={regtankReattemptApprovalFilter}
          />
          <TextInput
            mt="md"
            label="Search"
            onChange={handleSearchChange}
            placeholder="Search company name"
          />
        </Group>
        <div>
          <CustomTableForOrgDetails
            data={paginatedOrgs}
            refetchList={refetch}
          />
        </div>

        {!isLoading && organizations.length === 0 && (
          <div className={classes.noData}>
            <Text>No data available</Text>
          </div>
        )}

        <div className={classes.buttonContainer}>
          <div className={classes.rowSelection}>
            <Select
              placeholder={limit}
              data={limits}
              onChange={handleLimitChange}
            />
          </div>
          <ReactPaginate
            nextLabel=">"
            onPageChange={handlePageChange}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={Math.ceil(totalCount / parseInt(limit))}
            previousLabel="<"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
            forcePage={parseInt(page) - 1}
          />
        </div>
      </Box>
    </div>
  );
};

export default OrgDetailsPage;
